<ng-container *ngIf="cart$ | async as cart">
  <ng-container *ngIf="upgradeOffer$ | async as upgradeOffer">
    <div class="pr-large-x pr-small-y">
      <fcom-notification>{{ 'ticketUpgradePromotion.modal.notification' | finLocalization }}</fcom-notification>
      <ng-container
        *ngFor="let bound of cart.bounds; let i = index"
        [ngTemplateOutlet]="flight"
        [ngTemplateOutletContext]="{ bound: bound, isDeparture: i === 0 }"
      >
      </ng-container>
      <div class="flex mr-small-t benefits">
        <ng-container
          [ngTemplateOutlet]="fareFamilyOption"
          [ngTemplateOutletContext]="{
            fareFamily: upgradeOffer.currentFareFamily,
            price: prices$ | finMap: 'currentPrice' | async,
            selection: 'currentSelection',
            benefits: currentBenefits$ | async,
          }"
        ></ng-container>
        <div class="pr-small">
          <div class="border-top-dashed border-bottom-dashed nowrap font-body-1 medium-type pr-xxsmall-y align-center">
            {{ 'ticketUpgradePromotion.modal.updateTo' | finLocalization }}
            <div class="align-center arrow-wrapper">
              <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT"></fcom-icon>
            </div>
          </div>
        </div>
        <ng-container
          [ngTemplateOutlet]="fareFamilyOption"
          [ngTemplateOutletContext]="{
            fareFamily: upgradeOffer.upgradeFareFamily,
            price: prices$ | finMap: 'newPrice' | async,
            selection: 'newSelection',
            benefits: newBenefits$ | async,
          }"
        ></ng-container>
      </div>
      <div class="content pr-medium-y">
        <cms-unstyled-fragment
          class="benefits-information"
          [contentUrl$]="'fragments.benefitsInformation.url' | finLocalization | finToObservable"
        ></cms-unstyled-fragment>
      </div>
    </div>
    <ng-template #flight let-bound="bound" let-isDeparture="isDeparture">
      <div class="mr-xsmall-t">
        <div class="mr-xxsmall-b">
          <fcom-icon [class.rotate-active]="!isDeparture" [name]="SvgLibraryIcon.AIRCRAFT_HORIZONTAL_BLOCK">
          </fcom-icon>
          <span class="font-body-1 medium-type ps-xsmall-l">
            {{ (isDeparture ? 'bookingSearch.departure' : 'bookingSearch.return') | finLocalization }}
          </span>
        </div>
        <div class="font-body-1 mr-xxsmall-t">
          <span>{{ bound.departure.dateTime | finTime }} {{ bound.departure.locationCode }}</span>
          <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.AIRCRAFT_HORIZONTAL"></fcom-icon>
          <span>{{ bound.arrival.dateTime | finTime }} {{ bound.arrival.locationCode }} / </span>
          <span>{{ bound.uniqueAirlineNames.join(', ') }} / </span>
          <span>{{ bound.duration | finDuration | async }} / </span>
          <span>
            {{
              (bound.stops !== 0 ? 'bookingSummary.stops' : 'bookingSummary.directFlight')
                | finLocalization: [bound.stops]
            }}
            /
          </span>
          <span class="medium-type">
            {{ bound.fareFamilyBrandName }} /
            {{ prices$ | finMap: (isDeparture ? 'outboundPrice' : 'inboundPrice') | async | finPrice }}
            >
          </span>
          <span class="medium-type">
            {{ upgradeOffer.upgradeFareFamily.brandName }} /
            {{ prices$ | finMap: (isDeparture ? 'outboundUpgradePrice' : 'inboundUpgradePrice') | async | finPrice }}
          </span>
        </div>
      </div>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template
  #fareFamilyOption
  let-fareFamily="fareFamily"
  let-price="price"
  let-selection="selection"
  let-benefits="benefits"
>
  <div class="rounded-large border nordic-blue-100-border overflow-hidden">
    <div class="white-text pr-xsmall font-body-1" [ngStyle]="{ backgroundColor: fareFamily.brandColor }">
      <div>{{ 'ticketUpgradePromotion.modal.' + selection | finLocalization }}:</div>
      <div class="medium-type">{{ fareFamily.brandName }}</div>
      <div class="medium-type">{{ price | finPrice }}</div>
    </div>
    <div class="pr-xsmall font-body-2">
      <div>{{ fareFamily.brandNameDescription }}</div>
      <div class="border-top-dashed mr-small-t">
        <div class="ps-xxsmall-y" *ngFor="let benefit of benefits">
          <fin-benefit
            class="block"
            [benefit]="benefit"
            [enableBenefitChanges$]="false | finToObservable"
          ></fin-benefit>
        </div>
      </div>
    </div>
  </div>
</ng-template>
